import React from 'react';
import ReactDOM from 'react-dom';
import {
	createStore,
	applyMiddleware
} from 'redux'
import {
	Provider
} from 'react-redux'
import {
	BrowserRouter
} from "react-router-dom"
import thunk from 'redux-thunk';
import firebase from 'firebase/app'

import 'static/styles/flag-icon.css';
import 'static/styles/main.css';
import 'static/styles/panorama_viewer.css';
import 'static/styles/app.scss'

import App from './App';
import * as serviceWorker from './serviceWorker';
import reducer from 'reducers'

import firebaseConfig from './config/firebase/firebaseConfig'
import {
	checkLogin
} from './actions/asyncMember'
import Cookies from 'js-cookie'

let store = createStore(
	reducer,
	applyMiddleware(thunk)
)

// firebase initializing
firebase.initializeApp(firebaseConfig.FIREBASE)
firebase.auth().onAuthStateChanged(async user => {
	console.log('firebase on Auth State Changed call checkLogin')
	if(user){
		console.log('> current user is', user.displayName)
	}
	store.dispatch(checkLogin())
})

let redirecting = Cookies.get('redirecting')

// if (redirecting) {
// 	firebase.auth().getRedirectResult().then(result => {
// 		console.log('get Redirect Result')
// 		if (result.credential) {
// 			console.log('redirecting')
// 		}
// 	}).catch(function (error) {
// 		console.log('redirecting error: ', error)
// 	})
// }

firebase
	.auth()
	.getRedirectResult()
	.then(result => {
		console.log('get Redirect Result')
	})
	.catch(function (error) {
		console.log('redirecting error: ', error)
	})


// firebase
// 	.auth()
// 	.getRedirectResult()
// 	.then(
// 		function(result) {
// 			console.log(111, 'result')
// 		},
// 		function(error) {
// 			console.log(222, 'error')
// 		}
// 	);

ReactDOM.render( 
	<Provider store = {store} >
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</Provider> , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();